import { Field } from '@datx/core';
import { JsonApiModel } from '../core/jsonApi/jsonApiModel';
import { MetadataFieldDataType } from '../core/types';

export class GlobalMetadataJsonModel extends JsonApiModel {
  public static override readonly type = 'global-metadata';

  @Field({ isIdentifier: true })
  public id!: string;

  @Field()
  public name!: string;

  @Field()
  public password!: string;

  @Field()
  public description!: string;

  @Field()
  public fieldConf!: MetadataField[];

  @Field()
  public changedBy!: string;
}

export interface MetadataFieldHeader {
  name: string
  values: string[]
}

export interface MetadataFieldDetail {
  apiGetURL?: string
  label?: string
  subLabel?: string
  key?: string
  redaLabel?: string
  headers?: MetadataFieldHeader[]
}

export interface MetadataField {
  name: string
  label?: string
  mandatory: boolean
  datatype: MetadataFieldDataType
  detail: MetadataFieldDetail
  subFieldConf: MetadataField[]
}
